<template>
    <div>
        <input type="hidden" name="_token" :value="csrf">
        <input name="skillsApplicant[person_id]" type="hidden" v-model="this.person_id">
        <div class="row">
            <div class="col-5 form-group">
                <div>
                    <label class="out-form-label">{{ __('misc.select2') }} {{ __('forms.Skills.name') }}</label>
                    <select v-model="selectedSkill" class="form-control">
                        <option disabled value="">{{ __('misc.select') }}</option>
                        <option v-for="(skill) in this.skills" :key="skill.id" :value="skill.id"> {{ skill.name }}</option>
                    </select>
                </div>
            </div>


            <div class="col-5 form-group">
                <div>
                    <label class="out-form-label">{{ __('misc.select2') }} {{ __('forms.SkillsLevels.level') }}</label>
                    <select v-model="selectedLevel" class="form-control">
                        <option disabled value="">{{ __('misc.select') }}</option>
                        <option v-for="(level) in levels" :key="level.id" :value="level.id"> {{ level.title }}</option>
                    </select>
                </div>
            </div>

            <div class="col-2 form-group">
                <button @click="addRowSkill" class="btn btn--green mt-4" type="button">{{ __('misc.add')
                }}</button>
            </div>
        </div>


        <div class="row mt-2">
            <div class="col-12">
                <table class="table table-condensed">
                    <thead class="skills-table-head">
                        <tr>
                            <th class="skills-table-head-title">{{ __('forms.Skills.name') }}</th>
                            <th class="skills-table-head-title">{{ __('forms.SkillsLevels.level') }}</th>
                            <th class="skills-table-head-title text-center">{{ __('misc.actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in skillsGet" :key="index">
                            <td>{{ row.skill }}</td>
                            <td>
                                <select :name="'skillApplicant[' + index + ']'" v-model="row.level_id"
                                    @change="updateSkillLevel(row, $event)" class="form-control" style="width: 100%;">
                                    <option disabled value="">{{ __('misc.select') }}</option>
                                    <option v-for="(level) in levels" :value="level.id" :key="level.id"> {{ level.title }}
                                    </option>
                                </select>
                            </td>

                            <td class="d-flex justify-content-center">
                                <button type="button"
                                    :onClick="'app.__vue__.$refs.vue_popup.toggle(\'Note\', \'' + row.note_url + '\' )'"
                                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1 hrt-button">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>

                                <button type="button"
                                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1 hrt-button"
                                    @click="rmRowSkill(row)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style>

.skills-table-head-title {
    color: #1767A2 !important;
    font-weight: 800 !important;
}

</style>

<script>
export default {
    methods: {
        getSkills() {
            axios.get("/person-skills" + this.userUrl + "/" + this.person_id)
                .then((response) => {
                    this.skillsGet = response.data.skills;
                    this.action = response.data.action;
                });
        },
        updateSkillLevel(row, event) {
            axios.put("/people-skill" + this.userUrl + "/" + row.id,
                {
                    peopleSkills:
                    {
                        "person_id": row.person_id,
                        "skill_id": row.skill_id,
                        "skill_level_id": event.target.value
                    }
                })
                .then((response) => {
                    this.getSkills();
                });
        },
        rmRowSkill(row) {

            //Delete element
            axios.delete("/people-skill" + this.userUrl + "/" + row.id)
                .then((response) => {
                    this.getSkills();
                });
        },
        addRowSkill() {

            //Check if
            if (this.selectedSkill === '' || this.selectedLevel === '') {
                alert("Non puoi lasciare campi vuoti");
                return;
            }
            let postData = {
                peopleSkills: {
                    person_id: this.person_id,
                    skill_level_id: this.selectedLevel,
                    skill_id: this.selectedSkill,
                }
            };
            axios.post('/people-skill' + this.userUrl, postData)
                .then(response => {
                    this.getSkills();
                });
        },
    },
    mounted() {

        this.getSkills()
    },
    data() {
        return {
            action: "",
            selectedSkill: "",
            selectedLevel: "",
            skillsGet: null,
            userUrl: (this.is_admin) ? '' : '-user',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    props: {
        person_id: {
            type: Number,
            required: true
        },
        skills: {
            type: Array,
            required: true
        },
        levels: {
            type: Array,
            required: true
        },
        is_admin: {
            type: Boolean,
            required: true
        },

    },


}
</script>

